import '../Stylesheets/Badge.css';

export default function Badge({ children }) {
  return <div className="rh-badge">{children}</div>;
}
